import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    contactUs: 'Contact us',
    notifiedInviteName: `We have notified **{inviterName}** that we have received your information.`,
    question: 'Do you have a question?',
    quitPage: 'You may leave this page',
    receiveNotifications: `You will receive follow-up notifications at the following e-mail address: **{beneficiaryEmail}**`,
    title: 'Your identity information has been sent!',
  },
  fr: {
    contactUs: 'Contactez-nous',
    notifiedInviteName: `Nous avons notifié **{inviterName}** de la bonne réception de vos informations.`,
    question: 'Une question ?',
    quitPage: 'Vous pouvez quitter cette page.',
    receiveNotifications: `Vous recevrez les notifications de suivi à l’adresse e-mail suivante : **{beneficiaryEmail}**`,
    title: 'Vos informations d’identité sont envoyées !',
  },
} as const);
